import Gallery from '../../Gallery/Gallery';
import './ProjectGallery.scss';

const initGallery = () => {
  new Gallery(window.params.galleryImages);
};

initGallery();
